var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Field, getErrorMessage } from "./Field";
import { MultiSelect } from "./MultiSelect";
var FIELD_LABEL_STYLES = "capitalize font-semibold text-base mb-1";
export var MultiSelectField = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, name = _a.name, value = _a.value, options = _a.options, onChange = _a.onChange, placeholder = _a.placeholder, style = _a.style, className = _a.className, disabled = _a.disabled, errorMessage = _a.errorMessage, errors = _a.errors, closeMenuOnSelect = _a.closeMenuOnSelect, onSelect = _a.onSelect, selfControllable = _a.selfControllable, isMulti = _a.isMulti, creatable = _a.creatable, onCreateOption = _a.onCreateOption, fieldProps = __rest(_a, ["id", "label", "name", "value", "options", "onChange", "placeholder", "style", "className", "disabled", "errorMessage", "errors", "closeMenuOnSelect", "onSelect", "selfControllable", "isMulti", "creatable", "onCreateOption"]);
    var determinedErrorMessage = getErrorMessage({
        name: name,
        errorMessage: errorMessage,
        errors: errors,
    });
    var inputId = id + "-input";
    return (_jsx(Field, __assign({ name: name, label: label, className: className, labelClassName: FIELD_LABEL_STYLES, style: style, errorMessage: determinedErrorMessage, htmlFor: inputId }, fieldProps, { children: _jsx(MultiSelect, { ref: ref, id: id, inputId: inputId, closeMenuOnSelect: closeMenuOnSelect, name: name, value: value, options: options, disabled: disabled, onChange: onChange, placeholder: placeholder, onSelect: onSelect, isMulti: isMulti, creatable: creatable, onCreateOption: onCreateOption }, void 0) }), void 0));
});
